import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { AsyncState } from '../../shared/models/async.interface';
import { RootState } from '../../store';
import { RoleDisplay } from './models/RoleDisplay.interface';
import { Iam } from "@smash-sdk/iam/10-2019";

interface ListRoleState extends AsyncState {
    roles: RoleDisplay[];
}

export interface RoleState {
    list: ListRoleState;
}

export const listRoles = createAsyncThunk(
    'role/listRoles',
    async (_, thunkAPI) => {
        try {
            const iam2019 = new Iam();
            const { roles } = await iam2019.listRoles();
            if (roles) {
                return { roles: roles.map(role => ({ ...role, id: role.name, displayName: role.name.split('$').pop() as string })) }
            }
            return { roles: [] };
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ ...error });
        }
    }
)

export const initialState: RoleState = {
    list: {
        roles: [],
        isLoading: false,
        isSuccess: false,
        isError: false,
    }
}

export const roleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        reset: (state) => {
            state.list = {
                roles: state.list.roles,
                isLoading: false,
                isSuccess: false,
                isError: false,
            }
        }
    },
    extraReducers: (builder) => {
        builder
            // LIST KEYS
            .addCase(listRoles.pending, (state) => {
                state.list.isLoading = true;
                state.list.isError = false;
            })
            .addCase(listRoles.fulfilled, (state, action) => {
                state.list.isLoading = false;
                state.list.isSuccess = true;
                state.list.roles = action.payload.roles;
            })
            .addCase(listRoles.rejected, (state) => {
                state.list.isLoading = false;
                state.list.isError = true;
                state.list.roles = [];
            })
    }
});



export const { reset } = roleSlice.actions;

export const roleState = (state: RootState) => state.role;

export default roleSlice.reducer;